/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// import { pxToEm } from 'utils/styles/style_helpers';



/* ++++++++++ --------------- EXPORT --------------- ++++++++++ */
// PAGE : REQUEST DEMO : STYLES
// utliizes utils and CSS-IN-JS (JS objects converted to CSS using a library)
export default theme => ({
	requestdemo: {
		'& .gridset': {
			flexWrap: 'wrap',
			justifyContent: 'center',
			alignContent: 'center',
			alignItems: 'center'
		}
	}
});